import React, { useEffect, useState, useRef } from 'react';
import { Button, Loading, Message } from '@alifd/next';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import utils from '@/common/utils';
import styles from './index.module.scss';
// import { DingzhiService } from '@/service';
import { Servlets } from '@/service';
import LzMsg from '@/components/common/LzMsg';
import BaseCheck from './components/BaseInfo/index';
import SMSInfoForm from './components/PushInvitate/index';
import ProductLineSelect from './components/ProductLineSelect/index';
import CycleInput from './components/CycleInput/index';
// import useGetPoList from '@/hooks/public/useGetPoList';
// import useRichSmsNum from '@/hooks/public/useRichSmsNum';
import Cookie from 'js-cookie';
import CONSTANTS from '@/utils/constant';

const NewMisionCreate = (props) => {
  // const createRiceSmsRef = useRef(); // 新建富信引用
  // const { poList, showPoList } = useGetPoList(); // po列表, 是否展示po列表
  // const { richSmsAccountRemain, refreshRichSmsNum } = useRichSmsNum(); //账户余量初始值

  /** 展示校验函数抛出的异常,并滚动至异常处 */
  const ShowMessageError = (error: string, elementId = '') => {
    setTimeout(() => {
      // 抛出Error
      Message.warning(error);

      if (!elementId) return;

      // 页面滚动至抛出Error处
      const formElement = document.getElementById(elementId);

      if (formElement) formElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
    }, 500);
  };

  utils.setBreadcrumb({
    name: '模型',
    url: '/web/smsautomarket/marketing',
    children: {
      name: '自动化营销管理',
      url: '/web/smsautomarket/marketing',
    },
  });
  const history = useHistory();
  // 页面loading
  const [pageLoading, setPageLoading] = useState(true);
  // 能否修改投放时间
  const [canChangeTime, setCanChangeTime] = useState(true);
  // 新建1 复制2 查看3
  const [checkType, setCheckType] = useState(1);
  // 权益配置数据
  const [tempTplData, setTempTplData] = useState([]);
  // 人群过滤条件里对于checkbox是否勾选的标识
  const baseFilterConditionCheckboxs = {
    filterAlreadySendTip: false,
    filterOrderCountTip: false,
    filterMaxMemberCountTip: false,
    filterLastOrderTimeTip: false,
    filterCrowdTip: false,
  }
  // 麻烦这些备注参考短信营销任务创建
  const [filterConditionCheckboxs, setFilterConditionCheckboxs] = useState({
    ...baseFilterConditionCheckboxs
  });
  const [filterMaxMemberCountReal, setFilterMaxMemberCountReal] = useState(1);
  // 创建参数
  const [creatParams, setCreatParams] = useState({
    sendStrategy: 0,
    interactiveData: {},
    viewButton: {
      modelId: 6,
      firstHalf: [
        {
          select: true,
          crowdDesc: '新增会员，并从未在店铺购买过的用户',
          crowdName: '新会员开卡未购人群',
          crowdSubId: 1,
        },
        {
          select: false,
          crowdDesc: '新增会员，开卡后至今未在店铺购买过的用户',
          crowdName: '新会员开卡未购人群',
          crowdSubId: 2,
        },
      ],
      secondHalf: {
        addParam: {
          productLineList: [],
          skuList: [],
        },
        subShopId: null,
      },
    },
    taskEndTime: '',
    // "campaignModel": "模型名称",
    // "campaignModelId": 2134533121214,
    taskName: '',
    taskDesc: '',
    taskStartTime: '',
    // "crowdDelayTime": 7200000,
    crowdDelayTime: '',
    sendRule: 1,
    sendTime: '',
    smsType: 1, // 1 短信 2 富信
    smsContent: '',
    smsLongUrl: '',
    smsPoNum: '',
    smsShortUrl: '',
    smsSign: '',
    filterBlackList: false,
    addWhiteList: false,
    filterAlreadySend: 0,
    filterOrderCount : 0,
    filterMaxMemberCount : 0,
    filterMaxMemberCountShow : 0,
    filterLastOrderTime: 0, // 是否过滤最近一次下单时间（同上）
    filterCrowdId: '', // 是否过滤人群id（同上）
    filterCrowdName: '',
    testMobiles: [],
    testMobilesShow: null,
    detail: [ // 本着再不会改这个功能的心思，没有把这个，和PushRickMsg中Form里的、BaseInfo中Form里的变量提出来写在一起。所以后续接手的人员，需要注意，一旦有所修改，必须同步更改
        {
            type: 'title',
            name: '添加短信标题',
            content: '',
            draggable: false,
            canDelete: false,
            clicked: true,
            isUpload: false,
        },
        {
            type: 'content',
            name: '短信签名+文本内容+退订',
            content: '',
            draggable: true,
            canDelete: false,
            clicked: false,
            isUpload: false,
        }
    ]
  });

  // 预估人数
  const [forNum, setForNum] = useState(0);

  const [timevalue, setTimevalue] = useState([]);

  // 请求回来的po列表
  // const [polist, setPolist] = useState([]);

  // 复制时进页面传来的结束时间
  const [tempEndTime, setTempEndTime] = useState(0);
  // 点击复制时的长链和短链
  const [linkList, setLinkList] = useState({
    long: '',
    short: '',
  });
  // 获取店铺手机号
  const getPhoneList = () => {
    // DingzhiService.getSignphone()
    //   .then((resTest: any) => {
    //     setphoneList(resTest.data);
    //   })
    //   .catch((e) => console.log(e));
  };

  /**
   * 渲染基础信息模块
   */
  const showBaseInfo = () => {
    const BaseInfo = BaseCheck.components.Form;
    return (
      <BaseInfo
        params={creatParams}
        timevalue={timevalue}
        // showPolist={showPoList}
        // poList={poList}
        setTimevalue={(v) => {
          setTimevalue(v);
        }}
        setBaseInfo={(v) => { // , type = 0; type代表： 0是普通的change，1是切换短信富信时触发的，1时需要重置smsContent
          setCreatParams({...v}); //, smsContent: type === 0 ? v.smsContent : details
        }}
        checkType={checkType}
        canChangeTime={canChangeTime}
      />
    );
  };

  /**
   * 校验基础信息模块是否全部填写
   */
  const checkBaseInfoContent = async () => {
    return Promise.all(
      Object.keys(BaseCheck.data())
        .filter((key) => key in BaseCheck.validators)
        .map((key) => BaseCheck.validators[key](creatParams))
    );
  };

  // 选中的商品分组的id
  const [productId, setProductId] = useState([]);
  // 选中的商品分组信息
  const [productList, setProductList] = useState([]);
  // 选中商品分组的具体sku的所有信息
  const [selectedSku, setSelectedSku] = useState([]);

  const skuInfoSearch = (v, id, from) => {
    Servlets('getGoodsSku', {
      pageSize: 1000000,
      pageNo: 1,
      skuIds: [...id].join(','),
    })
      .then((res) => {
        const temp = [...v];
        for (let i = 0; i < temp.length; i++) {
          for (let y = 0; y < res.data.length; y++) {
            if (+res.data[y].skuId === +temp[i].skuId) {
              temp[i].name = res.data[y].name;
              temp[i].imagePath = res.data[y].imagePath;
            }
          }
        }
        if (+from === 1) {
          setForLine(temp);
        } else {
          setForSku(temp);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const [forLine, setForLine] = useState([]); // 按商品分组录入
  const [forSku, setForSku] = useState([]); // 按sku了录入
  const [repeatNum, setRepeatNum] = useState([]);
  /**
   * 商品分组
   */
  const showProductLine = () => {
    const ProductLine = ProductLineSelect.components.Form;
    return (
      <ProductLine
        params={creatParams}
        setRepeatNum={(v) => {
          setRepeatNum(v);
        }}
        setForLine={(v, id, from) => {
          skuInfoSearch(v, id, from);
        }}
        setForSku={(v, id, from) => {
          skuInfoSearch(v, id, from);
        }}
        setParams={(v, id) => {
          setCreatParams(v);
        }}
        productId={productId}
        changeProductId={(v) => {
          setProductId(v);
        }}
        productList={productList}
        changeProductList={(v) => {
          setProductList(v);
        }}
        checkType={checkType}
        // setSkuId={(v)=>{skuInfoSearch(v)}}
      />
    );
  };
  /**
   * 复购周期录入
   */
  const showCycleInput = () => {
    const CycleInputRecord = CycleInput.components.Form;
    return (
      <CycleInputRecord
        params={creatParams}
        forLine={forLine}
        setForLine={(v) => {
          setForLine(v);
        }}
        forSku={forSku}
        setForSku={(v) => {
          setForSku(v);
        }}
        selectedSku={selectedSku}
        productId={productId}
        setBaseInfo={(v) => {
          setCreatParams(v);
        }}
        productList={productList}
        checkType={checkType}
      />
    );
  };

  // 校验复购周日模块是否全部填写
  const checkCycleInputContent = async () => {
    return Promise.all(
      Object.keys(CycleInput.data())
        .filter((key) => key in CycleInput.validators)
        .map((key) => CycleInput.validators[key](creatParams.viewButton.secondHalf.addParam.skuList))
    );
  };

  const checkCrowdInfoContent = async () => {
    return Promise.all(
      Object.keys(ProductLineSelect.data())
        .filter((key) => key in ProductLineSelect.validators)
        .map((key) => ProductLineSelect.validators[key](creatParams))
    );
  };
  /**
   * 展示短信模块
   */
  const [details, setDetails] = useState(''); // 短信文案
  const [fileSize, setFileSize] = useState(''); // 上传文件的总大小
  const [fileList, setFileList] = useState([]); // 整个富信内容的列表，【标题内容文件】
  const showSmsInfo = () => {
  // const Content = creatParams.smsType === 1 ? SMSInfoForm.components.Form : RichSMSInfoForm.components.Form;
    const Content = SMSInfoForm.components.Form;
    return (
        // creatParams.smsType === 1 ?
        <Content
            params={creatParams}
            createTime={props.location.state?.data?.createTime ?? 0}
            // poList={poList}
            setTemplate={(v) => {
                setTemplate(v);
            }}
            // getPhoneList={() => {
            //     getPhoneList();
            // }}
            setEnough={(v) => {
                setEnough(v);
            }}
            // phoneList={phoneList}
            setTestParams={(v) => {
                setTestParams(v);
            }}
            testParams={testParams}
            linkList={linkList}
            setLink={(v) => {
                setLinkList(v);
            }}
            checkType={checkType}
            setInvitateInfo={(v) => {
                setCreatParams(v);
            }}
            tempTplData={tempTplData}
            forNum={forNum}
            filterCondition={filterConditionCheckboxs}
            setFilterCondition={(v) => {
                setFilterConditionCheckboxs(v);
            }}
            filterMaxMemberCountReal={filterMaxMemberCountReal}
        />
    );
  };

  /**
   * 校验短信模块是否全部填写
   */
  const checkSmsInfoContent = async () => {
    return Promise.all(
      Object.keys(SMSInfoForm.data())
        .filter((key) => key in SMSInfoForm.validators)
        .map((key) => SMSInfoForm.validators[key]({...creatParams, ...filterConditionCheckboxs}))
    );
  };
  const checkBaseInfo = async () => {
    const currentSmsType = Number(creatParams.smsType ?? 1);
    const temp = { ...creatParams,
      smsType: currentSmsType,
      filterAlreadySend: creatParams.filterAlreadySend ?? 0,
      filterOrderCount : creatParams.filterOrderCount ?? 0,
      filterMaxMemberCount : creatParams.filterMaxMemberCount ? filterMaxMemberCountReal : 0,
      filterMaxMemberCountShow : creatParams.filterMaxMemberCount ?? 0,
      filterLastOrderTime : creatParams?.filterLastOrderTime ?? 0,
      filterCrowdId : creatParams?.filterCrowdId ?? '',
      filterCrowdName : creatParams?.filterCrowdName ?? '',
    };
    try {
      temp.campaignModelId = creatParams.viewButton.modelId;
      temp.sendRule = Number(creatParams.sendRule);

      // 这里存两个数组是为了方便反显
      temp.interactiveData = {
        forSku,
        forLine,
        productList,
        productId,
      };

      // 如果选了商品分组，就要进行一波去重
      if (temp.viewButton.firstHalf[0].select) {
        // 遍历所有重复sku 删掉day值较大的
        // repeatNum是所有重复的元素
        if (repeatNum.length === 0) {
          temp.viewButton.secondHalf.addParam.skuList = [...forLine];
        } else {
          const tempLine = [...forLine];
          // 对每一个重复元素遍历
          repeatNum.forEach((item, index) => {
            let base = 0; // 天数
            let delet = 0; // 被删的索引
            for (let o = 0; o < tempLine.length; o++) {
              if (+item === +tempLine[o].skuId) {
                if (+base === 0) {
                  (base = tempLine[o].day), (delet = o);
                } else {
                  // 谁的day小，谁被删
                  if (base < tempLine[o].day) {
                    tempLine.splice(o, 1);
                  } else {
                    tempLine.splice(delet, 1);
                  }
                  // 删完了索引得减一
                  o--;
                }
              }
            }
          });
          temp.viewButton.secondHalf.addParam.skuList = tempLine;
        }
        // 如果选了sku，直接赋值就行
      } else if (temp.viewButton.firstHalf[1].select) {
        temp.viewButton.secondHalf.addParam.skuList = [...forSku];
      }
      if (!temp.smsModelId) {
        temp.smsModelId = -1;
      }
      // 此处要传的是前一页的模型名称
      if (Number(checkType) === 1) {
        // 创建时获取的model名
        temp.campaignModel = props.location.state.data.taskName;
      } else {
        // 复制时获取的model名
        temp.campaignModel = props.location.state.data.taskType;
      }
      // 判断选择短信模板后用户是否进行过修改（决定是否传模板id）
      if (template.content !== temp.smsContent && currentSmsType === 1) {
        temp.smsModelId = -1;
      } else {
        temp.smsModelId = template.id;
      }

      if (currentSmsType === 1) {
        if (temp.smsContent.indexOf('3.cn') !== -1) {
          temp.smsContent = temp.smsContent.replace(
            `${linkList.short}`,
            '#oldshortLink'
          );
          temp.smsLongUrl = linkList.long;
          temp.smsShortUrl = linkList.short.replace(' ', '');
        } else {
          temp.smsLongUrl = '';
          temp.smsShortUrl = '';
        }
      }
      if (!temp.taskStartTime) {
        LzMsg.error('请选择活动开始时间');
        return;
      }
      if (!temp.taskEndTime) {
        LzMsg.error('请选择活动结束时间');
        return;
      }
      if (
        creatParams.taskStartTime + creatParams.sendTime <
        new Date().getTime()
      ) {
        LzMsg.error('请正确选择活动起始时间范围');
        return;
      }
      await checkBaseInfoContent();
      await checkCycleInputContent();
      temp.crowdDelayTime = +temp.sendTime - 3600000;
      // await checkCrowdInfoContent();
      if (creatParams.viewButton.secondHalf.addParam.skuList.length === 0) {
        LzMsg.error('请选择商品分组');
        return;
      }
      if (currentSmsType !== 1) {
        LzMsg.error('当前仅支持创建短信投放任务');
        return;
      }
      if (currentSmsType === 1) {
        await checkSmsInfoContent();
        if (creatParams.smsContent.indexOf('3.cn') !== -1 && !linkList.long) {
          LzMsg.error(
            '请填入由系统自带短链接工具生成的短链，内容中其他渠道生成的短链接会造成发送失败。'
          );
        } else if (creatParams.smsContent.indexOf('#oldshortLink') !== -1) {
          LzMsg.error('错误的短信内容：#oldshortLink');
        } else if (
          creatParams.smsContent.indexOf('3.cn') !== -1 &&
          creatParams.smsContent.indexOf(` ${linkList.short} `) === -1
        ) {
          LzMsg.error('短链接前后请添加空格！');
        } else {
          setPageLoading(true);
          // 如果有传来的结束时间且未变更过的话 变成当天的23：59：59
          if (Number(tempEndTime) !== Number(temp.taskEndTime)) {
            temp.taskEndTime = Number(moment(temp.taskEndTime).endOf('days').format('x'))
            setTimeChange(true);
          }
          temp.smsContent = `${temp.smsContent} ${CONSTANTS.LZ_SMS_CANCEL_WORD}`;
          temp.sendRule = 1;
          temp.taskType = 6;

              Servlets('setAutoNewCompaign', temp)
                .then((res) => {
                  if (!res.success) {
                    setPageLoading(false);
                    ShowMessageError(res.resp_msg, '');
                  } else {
                    setPageLoading(false);
                    history.push('/smsautomarket/marketing', {
                      from: 'resultData',
                    });
                    LzMsg.success('活动创建成功');
                  }
                })
                .catch(() => {
                  // 如果后端出现问题，把占位符再替回短链
                  if (
                    temp.smsContent.indexOf('#oldshortLink') !== -1 &&
                    linkList.long
                  ) {
                    temp.smsContent = temp.smsContent.replace(
                      '#oldshortLink',
                      `${linkList.short}`
                    );
                  }
                  temp.smsContent = temp.smsContent.replace(` ${CONSTANTS.LZ_SMS_CANCEL_WORD}`, '');
                  // 把结束时间变回去
                  if (timeChange) {
                    setTimeChange(false);
                  }
                  setPageLoading(false);
                  setCreatParams(temp);
                });
        }
      }
    } catch (e) {
      LzMsg.error(e.message);
      setPageLoading(false);
    }
  };

  useEffect(() => {
    // 拿短信签名
    Servlets('getTitle', {}).then(async (res: { data: string }) => {
      const { shopName } = res.data;
      Servlets('getSmssign', { shopName }).then((res: { data: string }) => {
        if (!res.data) {
          setPageLoading(false);
          return;
        }
          setCheckType(props.location.state.checkType);
          let tempObj = { ...creatParams };
          const tempTest = { ...testParams };
          // // 拿到预留测试手机号
          // DingzhiService.getSignphone()
          //   .then((resTest: any) => {
          //     setphoneList(resTest.data);
          //     // 如果有测试手机号 则赋值首个到测试参数对象
          //     if (resTest.data[0]) {
          //       tempTest.receivePhone = [resTest.data[0].phone];
          //     }
              // 复制或查看要走接口拿数据
              if (props.location.state && props.location.state.checkType !== 1) {
                Servlets('checkAutoNewCompaign', {
                  id: props.location.state.data.id,
                })
                  .then((resp: any) => {
                    // console.log(resp,"resp");
                    // 数据格式完全按请求回的数据来
                    tempObj = resp.data;
                    tempObj.smsContent = Number(props.location.state.checkType) === 3 && +props.location.state.data.createTime < CONSTANTS.UP_TIME ? tempObj.smsContent : tempObj.smsContent.replace(' 回T退', '');
                    // 在此基础上赋值上签名
                    tempObj.smsSign = res.data;
                    tempObj.filterAlreadySend = tempObj.filterAlreadySend ? tempObj.filterAlreadySend : null;
                    tempObj.filterOrderCount = tempObj.filterOrderCount ? tempObj.filterOrderCount : null;
                    tempObj.filterMaxMemberCount = tempObj.filterMaxMemberCountShow ? tempObj.filterMaxMemberCountShow : null;;
                    tempObj.filterLastOrderTime = tempObj?.filterLastOrderTime ? tempObj?.filterLastOrderTime : null;
                    tempObj.filterCrowdId = tempObj?.filterCrowdId ? tempObj?.filterCrowdId : null;
                    tempObj.filterCrowdName = tempObj?.filterCrowdName ? tempObj?.filterCrowdName : null;
                    tempObj.testMobiles = [],
                    tempObj.testMobilesShow = null,
                    setFilterConditionCheckboxs(
                      {
                        ...filterConditionCheckboxs,
                        filterAlreadySendTip: tempObj.filterAlreadySend ? true : false,
                        filterOrderCountTip: tempObj.filterOrderCount ? true : false,
                        filterMaxMemberCountTip: tempObj.filterMaxMemberCount ? true : false,
                        filterLastOrderTimeTip: tempObj?.filterLastOrderTime ? true : false,
                        filterCrowdTip: tempObj?.filterCrowdId ? true : false,
                      }
                    )
                    setProductList(resp.data.interactiveData.productList);
                    setProductId(resp.data.interactiveData.productId);
                    setForSku(resp.data.interactiveData.forSku);
                    setForLine(resp.data.interactiveData.forLine);
                    // 赋值时间
                    if (
                      resp.data.taskStartTime ||
                      resp.data.taskEndTime
                    ) {
                      //  任务时间
                      const timevalue = [
                        moment(resp.data.taskStartTime),
                        moment(resp.data.taskEndTime),
                      ];
                      setTempEndTime(resp.data.taskEndTime);
                      setTimevalue(timevalue);
                    }
                    // 如果是查看，且有短链的话，把短信内容的#oldshortLink换成正常短链
                    if (tempObj.smsShortUrl) {
                      tempObj.smsContent = tempObj.smsContent.replace(
                        '#oldshortLink',
                        `${tempObj.smsShortUrl}`
                      );
                    }
                    // 查看或赋值 反显时把` ${CONSTANTS.LZ_SMS_CANCEL_WORD}`也去掉
                    tempObj.smsContent = tempObj.smsContent.replace(` ${CONSTANTS.LZ_SMS_CANCEL_WORD}`, '');
                    const smsModelId = tempObj.smsModelId || props.location.state.data.smsModelId || '';
                    tempObj.smsModelId = smsModelId;
                    setTemplate({
                      id: smsModelId,
                      content: smsModelId ? tempObj.smsContent || '' : '',
                    });
                    // 如果是复制，名字加副本
                    if (Number(props.location.state.checkType) === 2) {
                      tempObj.taskName = `${props.location.state.data.taskName}副本`;
                      // 如果是复制且又短链，赋值linklist以通过校验
                      if (tempObj.smsShortUrl) {
                        setLinkList({
                          long: tempObj.smsLongUrl,
                          short: tempObj.smsShortUrl,
                        });
                      }
                    }
                    tempTest.fullContent = tempObj.smsContent;
                    tempObj.smsType = Number(props.location.state.data.smsType ?? tempObj.smsType ?? 1);
                    setTestParams(tempTest);
                    // console.log(tempObj,'tempObj');
                    setCreatParams(tempObj);
                    setPageLoading(false);
                  })
                  .catch(() => {
                    setPageLoading(false);
                  });
                // 如果是新建，路由传参只传viewbutton，其他走默认值
              } else if (
                props.location.state &&
                props.location.state.checkType === 1
              ) {
                tempObj.smsSign = res.data;
                tempObj.taskDesc = `${moment().format(
                  'M'
                )}月${moment().format('D')}日创建活动`;
                tempObj.viewButton = props.location.state.data.viewButton;
                tempObj.smsType = Number(props.location.state.data.smsType ?? 1);

                setCreatParams(tempObj);
                setPageLoading(false);
                setTestParams(tempTest);
              }
            // })
            // .catch((e) => {
            //   console.log(e);
            //   setPageLoading(false);
            // });
        })
      //   .catch(() => {
      //     setPageLoading(false);
      //   });
      // })
      .catch(() => {
        setPageLoading(false);
      });

    })
    .catch(() => {
      setPageLoading(false);
    });
  }, []);

  // 发送测试短信参数
  const [testParams, setTestParams] = useState({
    fullContent: '',
    receivePhone: [],
    smsTestType: 3, // 催付1 群发2 此处3
  });
  const [phoneList, setphoneList] = useState([]);

  // 参数的结束时间是否变为当天的23：59：59
  const [timeChange, setTimeChange] = useState(false);

  // 是否余额足够
  const [isEnough, setEnough] = useState(true);

  // 暂存模板内容，来判断用户选了模板后是否进行了更改，决定是否变模板id为-1
  const [template, setTemplate] = useState({
    content: '',
    id: '',
  });

  return (
    <div>
      <div className={styles.pageContent}>{showBaseInfo()}</div>
      <div style={{ marginBottom: '10px' }}>{showProductLine()}</div>
      <div style={{ marginBottom: '10px' }}>{showCycleInput()}</div>
      <div style={{ marginBottom: '10px' }}>{showSmsInfo()}</div>
      <div className={styles.finishContent}>
        {Number(checkType) === 3 ? (
          <div>
            <Button
              type="normal"
              className={styles.finishButton}
              onClick={() => {
                history.push('/smsautomarket/marketing', {
                  from: 'resultData',
                  params: props.location.state.params
                });
              }}
            >
              返回
            </Button>
          </div>
        ) : (
          <div>
            <Button
              type="primary"
              className={styles.finishButton}
              onClick={() => checkBaseInfo()}
            >
              确认创建
            </Button>
            <Button
              type="normal"
              className={styles.finishButton}
              style={{ marginRight: '20px' }}
              onClick={() => {
                history.push('/smsautomarket/marketing', {
                  from: 'cancle',
                });
              }}
            >
              取消
            </Button>
          </div>
        )}
      </div>
      <Loading visible={pageLoading} fullScreen shape="fusion-reactor" />
    </div>
  );
};

export default NewMisionCreate;
